<div class="root">
  <a i18n class="visually-hidden-focusable skip-to-content-sub-menu" href="#admin-settings-content" (click)="$event.preventDefault(); adminContent.focus()">Skip the sub menu</a>

  <div class="margin-content">
    <my-horizontal-menu i18n-h1 h1="Settings" h1Icon="config" [menuEntries]="menuEntries"></my-horizontal-menu>
  </div>

  <div #adminContent tabindex="-1" id="admin-settings-content" class="margin-content outline-0">
    <router-outlet></router-outlet>
  </div>
</div>
